import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { list } from "sources/books/employees";
import { removeUser } from "sources/books/usersGroups";
import AddUsertoGroup from "./addUserToGroup";

class UsersGroupUsers extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            {
                Header: "ID пользователя",
                accessor: "userId",
                id: "id",
                width: 100,
                filterable: false,
                sortable: false,
                Cell: ({ value }) => value,
            },
            {
                Header: "Пользователь",
                accessor: "userName",
                filterable: true,
                sortable: false,
                Cell: ({ value }) => value,
                id: "userId",
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{ url: list, inputProps: { name: "userId" }, propName: "fullNameOrEmail" }}
                    />
                ),
            },
            {
                Header: "",
                accessor: "actions",
                sortable: false,
                notExportable: true,
                width: 100,
                Cell: ({ row }) => {
                    const deleteAction = () =>
                        this.props.modal({
                            name: "confirm",
                            title: "Удаление пользователя",
                            text: "Вы уверены, что хотите удалить пользователя из группы?",
                            buttons: { confirm: "Удалить", cancel: "Отменить" },
                            action: () =>
                                removeUser({
                                    groupId: this.props.match.params.groupId,
                                    userId: row.original.userId,
                                }).then(() => this.props.mergeParams({})),
                        });
                    return (
                        <div className="btn btn-xs btn-outline-danger" onClick={deleteAction}>
                            Удалить
                        </div>
                    );
                },
            },
        ];
    }

    componentWillUnmount() {
        this.props.clearParams();
    }

    renderCreateButton = () => {
        const { modal, mergeParams, match } = this.props;
        const addUserAction = () =>
            modal({
                name: "default",
                windowMod: "wide",
                title: "Добавление пользователя",
                CustomBody: AddUsertoGroup,
                bodyData: { mergeParams, groupId: match.params.groupId },
            });
        return (
            <div className="btn btn-brand btn-xs" onClick={addUserAction}>
                Добавить пользователя
            </div>
        );
    };

    render() {
        const { getList, ...props } = this.props;

        return (
            <div className="container-fluid h-100 pb-3">
                <div className="card card-body h-100">
                    <div className="d-flex flex-column h-100">
                        <div className="d-flex justify-content-end pb-3">{this.renderCreateButton()}</div>
                        <div className="flex-grow-1 overflow-hidden">
                            <SharedReactTable
                                {...props}
                                wrapCname="h-100"
                                getList={(params) =>
                                    getList({ ...params, groupId: parseInt(props.match.params.groupId) })
                                }
                                columns={this.state.tableColumns}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default tableContainer(UsersGroupUsers, "users-group-users");
